module.exports = __webpack_public_path__ + "img/entry_btn.e23d76ec.png";